import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildLegalHead } from "@/lib/legalSeo";

export const Route = createFileRoute("/cookie-policy")({
  head: () => buildLegalHead("/cookie-policy"),
  component: lazyRouteComponent(() => import("@/pages/CookiePolicy")),
});
